import React from 'react';
import Navbar from '../components/Navbar';
import { GALLERY_IMAGES } from '../data/galleryImages';
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from 'react-images';

export default class MyGallery extends React.Component {
    constructor() {
        super();
        this.state = { currentImage: 0 };
        this.closeLightbox = this.closeLightbox.bind(this);
        this.openLightbox = this.openLightbox.bind(this);
    }

    openLightbox(event, obj) {
        this.setState({
            currentImage: obj.index,
            lightboxIsOpen: true,
        });
    }

    closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }

    render() {
        return (
            <div className="dark-background" style={{minHeight: '90vh', paddingBottom: '40px'}}>
                <div className="container">
                    <div className="row justify-content-center page-title-wrapper" style={{marginBottom: '20px'}}>
                        <div className="col-md-3 col-sm-10" style={{textAlign: 'center', maxWidth: '250px', minWidth: '200px'}}>
                            <h1 className="font-satisfy font-peach page-title">Gallery</h1>
                            <hr className="flaired-edge-separator"/>
                        </div>
                    </div>

                    <div style={{marginBottom: '15px'}}>
                        <Gallery photos={GALLERY_IMAGES} onClick={this.openLightbox} margin={5} />
                        <ModalGateway>
                            {this.state.lightboxIsOpen ? (
                                <Modal onClose={this.closeLightbox} allowFullscreen={false}>
                                <Carousel views={GALLERY_IMAGES} currentIndex={this.state.currentImage} />
                            </Modal>
                            ) : null}
                        </ModalGateway>
                    </div>

                    <h5 onClick={() => { window.scrollTo(0, 0); }} className="back-to-top-link">Back to top</h5>
                </div>

                <Navbar links={[
                    { text: 'Home', reference: '/home' },
                    { text: 'Resume', reference: '/resume' },
                    { text: 'Gallery', reference: '/gallery', extraClasses: 'active-link' },
                    { text: 'Voice', reference: '/voice' },
                    { text: 'Press', reference: '/press' },
                    { text: 'Contact', reference: '/contact' }
                ]}/>
            </div>
        );
    }
}
